import React, { useContext } from 'react';
import classNames from 'classnames';
import dayjs from 'dayjs';
import 'dayjs/locale/pl';

import type { ReviewItemMessageInterface } from 'components/review/review.interface';
import ReviewItemMessageAvatar from 'components/review/review-item-messages/review-item-message-avatar';
import Link from 'atomic/link/link';

import './review-item-message.scss';
import { SSRApiContext } from '@ecommerce/nest-ssr/common';

dayjs.locale('pl');

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ReviewItemMessageProps extends ReviewItemMessageInterface {}

const ReviewItemMessage: React.FC<ReviewItemMessageProps> = ({ type, author, content, hidden, createdAt }) => {
    const api = useContext(SSRApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const avatar = type === 'client'
        ? (
            <div className="review-item__avatar">
                <i className="review-item__avatar-icon opicon-avatar" />
            </div>
        )
        : <ReviewItemMessageAvatar type={type} />;

    const classes = classNames({
        'review-item__message': true,
        'review-item__message--hidden': hidden,
        'review-item__message--variant': ['delivery', 'comment'].includes(type)
    });

    return (
        <div className={classes}>
            <div className="review-item__message-avatar">
                {avatar}
            </div>
            <div className="review-item__message-content">
                <div className="review-item__message-header">
                    <div className="review-item__message-author">
                        {type === 'delivery' ? 'Dostawca: ' : ''}
                        {
                            type === 'delivery' && author?.url
                                ? (
                                    <Link href={`/opinie/${author.url}`}>
                                        {author.name}
                                    </Link>
                                )
                                : author?.name
                        }
                    </div>
                    {createdAt && (
                        <div className="review-item__message-date">
                            { dayjs(createdAt).format(api.getDevice() === 'mobile' ? 'D MMM YYYY | HH:mm' : 'D MMMM YYYY | HH:mm') }
                        </div>
                    )}
                </div>
                <div className="review-item__message-text">
                    {content}
                </div>
            </div>
        </div>
    );
};

export default ReviewItemMessage;
